<script>
import Progress from 'element-ui/lib/progress';

export default Progress;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/progress.css';

.el-progress__text {
  font-size: $small-font-size !important;
}
</style>
